<template>
  <v-row no-gutters align="end" justify="end" v-if="type === 'inventory'">
    <span class="subtitle-1" v-if="data">{{
      data.computedQuantity | round2
    }}</span>
    <span class="ml-1 caption">{{ getUnit }}</span>
  </v-row>
  <v-row no-gutters align="end" justify="end" v-else-if="type === 'last-entry'">
    <span v-if="data" class="subtitle-1">{{ data.created | localFormat }}</span>
  </v-row>
  <v-row
    no-gutters
    align="end"
    justify="end"
    v-else-if="type === 'correction-value'"
  >
    <v-tooltip top max-width="20rem" v-if="data">
      <template v-slot:activator="tooltip">
        <v-row
          v-if="data"
          no-gutters
          v-on="tooltip.on"
          align="end"
          justify="end"
        >
          <span class="subtitle-1">{{
            (Number(data.value) * 100) | round2
          }}</span>
          <span class="ml-1 caption">%</span>
        </v-row>
      </template>
      <span v-if="data.value < 0"
        >Signifie qu'en moyenne la production consomme en moyenne
        {{ Math.abs(Number(data.value) * 100) | round2 }}% plus du produit que
        ce qui est planifié</span
      >
      <span v-if="data.value > 0"
        >Signifie qu'en moyenne la production consomme en moyenne
        {{ Math.abs(Number(data.value) * 100) | round2 }}% moins du produit que
        ce qui est planifié</span
      >
    </v-tooltip>
  </v-row>
</template>

<script>
import { api } from "@/api";
import moment from "moment";
import { mapGetters } from "vuex";
export default {
  name: "InventoryDetail",
  props: {
    product: {
      required: true
    },
    type: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  mounted() {
    if (this.product !== undefined && this.product !== null) {
      this.getData();
    }
  },
  computed: {
    ...mapGetters(["getStoreId", "getProducts"]),
    getUnit() {
      const p = this.getProducts.find(x => x.id == this.product);
      return p && p.data ? p.data.unite_mesure_inventory : "";
    }
  },
  data() {
    return {
      data: undefined
    };
  },
  methods: {
    async getData() {
      try {
        this.$emit("update:loading", true);
        if (this.type === "correction-value") {
          const data = await api.getInventoryCorrectionValues({
            product: this.productId
          });
          if (data.length > 0) {
            this.data = data[0];
          } else {
            this.data = undefined;
          }
        } else {
          const record = await api.getInventoryRecords({
            product: this.product,
            latest: true
          });
          if (record.length > 0) {
            this.data = record[0];
          } else {
            this.data = undefined;
          }
        }
      } finally {
        this.$emit("update:loading", false);
      }
    },
    async updateInventory(value) {
      try {
        this.$store.dispatch("slo");
        if (Number(this.data.computedQuantity) !== Number(value)) {
          const data = {
            fk_product: this.product,
            store: this.getStoreId,
            date: moment(new Date(Date.now())).format(
              "YYYY-MM-DDTHH:mm:ss.SSSSSSZ"
            ),
            quantity: value,
            is_deleted: false
          };
          const res = await api.postInventoryRecord(data);
          await this.$store.dispatch("updateInventoryRecord", res);
          await this.getData();
        }
      } finally {
        this.$store.dispatch("elo");
      }
    }
  },
  watch: {
    product(v) {
      if (v !== undefined && v !== null) {
        this.getData();
      } else {
        this.data = undefined;
      }
    }
  }
};
</script>

<style></style>
